/* eslint max-classes-per-file: 0 */
/* eslint class-methods-use-this: 0 */

import {
  UserActionCollection,
} from '@/typings/api/User'

import { Fabric } from '@/store/createCrudModule'
import { UsersActionsAdapter } from './UsersActionsAdapter'


export const fabric = Fabric<UserActionCollection, UserActionCollection>()

type S = UsersActionsState
type G = UsersActionsGetters
type M = UsersActionsMutations
type A = UsersActionsActions


export class UsersActionsState extends fabric.State {
}

export class UsersActionsGetters extends fabric.Getters<S> {
}

export class UsersActionsMutations extends fabric.Mutations<S> {
}

export class UsersActionsActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new UsersActionsAdapter();

  protected readonly idName = 'id';
}
